<template>
    <div id="HotGoods">
        <nav-bar>
            <div slot="left">
                <van-icon name="arrow-left" color="#666666" size="20" @click="goBack"/>
            </div>
            <div slot="title">{{langText.hotProduct}}</div>
        </nav-bar>
        <div style="background: #f8f6f7; width: 100%; height: 5px;"></div>
        <van-pull-refresh v-model="refreshing" @refresh="onRefresh">
            <van-list
                    v-model="loading"
                    :finished="finished"
                    finished-text="没有更多了"
                    @load="onLoad">
<!--                <van-grid :column-num="2"  :gutter="10">-->
<!--                    <van-grid-item v-for="(item, index) of goodsList" :to="'/goods/goodsInfo/'+ item.id">-->
<!--                        <van-image :src="item.pic" width="100%"/>-->
<!--                        <span>{{item.name}}</span>-->
<!--                        <span>{{item.description}}</span>-->
<!--                        <span style="color: red">￥{{item.price}}</span>-->
<!--                    </van-grid-item>-->
<!--                </van-grid>-->
                <goods-list :goods="goodsList"/>

            </van-list>
        </van-pull-refresh>
    </div>
</template>

<script>
    import {Icon, Toast, List, PullRefresh, Image, Grid, GridItem } from 'vant';

    import NavBar from "@/components/common/navbar/NavBar";
    import {getHotProductList} from "../../network/goods/goods";
    import goodsList from "@/components/content/goodsList/goodsList";
    import { langPackage } from "@/config/lang/hotProductList";
    import { selectLang } from "@/config/setLanguage"

    export default {
        name: "HotGoods",
        components: {
            NavBar: NavBar,
            goodsList:goodsList,
            [Icon.name]: Icon,
            [Toast.name]: Toast,
            [List.name]: List,
            [PullRefresh.name]: PullRefresh,
            [Grid.name]: Grid,
            [GridItem.name]: GridItem,
            [Image.name]: Image
        },
        data() {
            return {
                goodsList: [],
                refreshing: true,
                loading: false,
                finished: false,
                pageNum: 0,
                pageSize: 8,
                langText:"",
                commonText:""
            }
        },
        methods: {
            goBack() {
                this.$router.push('/home');
            },
            onLoad() {
                getHotProductList({pageNum: this.pageNum, pageSize: this.pageSize}).then(res => {
                    if(this.refreshing) {
                        this.refreshing = false;
                        this.goodsList = res.data;
                    }else{
                        if(this.orderList[0]){
                            this.goodsList= this.goodsList.concat(res.data)
                        }else {
                            this.goodsList = res.data;
                        }
                    }
                    if(!res.data) {
                        this.finished = true
                    } else if(res.data.length < this.pageSize){
                        this.finished = true
                    }
                    this.loading = false;
                    //增加页数
                    this.pageNum++;
                }).catch( err => {
                    this.refreshing = false;
                    this.loading = false
                    this.finished = true
                })


            },
            onRefresh() {
                //弹窗显示
                Toast.loading({
                    duration: 0,
                    message: '加载中...',
                    forbidClick: true,
                });
                //延迟提交
                setTimeout(() => {
                    Toast.clear();
                    // 清空列表数据
                    this.finished = false;
                    this.orderList = [];
                    // 重新加载数据
                    // 将 loading 设置为 true，表示处于加载状态
                    this.loading = true;
                    this.pageNum = 0;
                    this.onLoad();
                }, 1000)

            },
        },
        created() {
          selectLang(langPackage).then(langtxt =>{
            this.langText = langtxt.langtxt;
            this.commonText = langtxt.common;
          });
            //重置滚动条代码
            this.$router.afterEach((to, from, next) => {
                window.scrollTo(0, 0)
            })
        }
    }
</script>

<style scoped>
    @import "~@/assets/css/index/style.css";


    #HotGoods{
       width: 100%;
       height: 1000px;
       background:  #f6f8f7;
    }


    .van-nav-bar {
        box-shadow: 0px 1px 3px 0px rgba(0, 0, 0, .5);
        background-color: #ffffff;
    }

    .van-tabs {
        margin-top: 46px;
    }

    .van-pull-refresh {
        margin-top: 63px;
    }

</style>
